import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import PersonalityTest from "./components/PersonalityTest";
import ResultsPage from "./components/ResultsPage";

function App() {
  return (
    <div className="App min-h-screen bg-gradient-to-br from-orange-50 via-pink-50 to-purple-50">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/test" element={<PersonalityTest />} />
          <Route path="/results/:personality" element={<ResultsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;